
     const hoodies= [
      {
        id: 1,
        name: "Royal Biege Hoodie",
        oldPrice: 4999,
        price: 3450,
        sizes: ["M", "L", "XL"],
        color: "Biege",
        // material: "100% Organic Cotton Fleece",
        description:
          "Made from a soft fleece blend for all-day comfort. Clean streetwear design with minimal chest logo. Adjustable drawstrings with metal tips for style and fit. Relaxed drop- shoulder cut for laid - back comfort. Ribbed cuffs and hem keep the shape sharp. Perfect for everyday wear or layered street looks. ",
      imgs: [
      "/Products/Hoodies/Cream/1.webp",
      "/Products/Hoodies/Cream/2.webp",
      "/Products/Hoodies/Cream/3.webp",
      "/Products/Hoodies/Cream/4.webp",
      "/Products/Hoodies/Cream/5.webp",
      "/Products/Hoodies/Cream/6.webp",
      ],
  },
    {
      id: 2,
      name: " Royal White Hoodie ",
      oldPrice:4999,
      price: 3450,
      sizes: [ "M", "L", "XL"],
      color: "White",
      // material: "Cotton Blend",
      description:
        "Made from a soft fleece blend for all-day comfort. Clean streetwear design with minimal chest logo. Adjustable drawstrings with metal tips for style and fit. Relaxed drop-shoulder cut for laid-back comfort. Ribbed cuffs and hem keep the shape sharp. Perfect for everyday wear or layered street looks",
      imgs: [
        "/Products/Hoodies/5.webp",
      "/Products/Hoodies/1.webp",
      "/Products/Hoodies/2.webp",
      "/Products/Hoodies/3.webp",
      "/Products/Hoodies/4.webp",
      ],
},
{
  id: 3,
    name: "Royal Monark Hoodie ",
      oldPrice: 4999,
        price: 3450,
          sizes: ["M", "L", "XL"],
            color: "Forest Green",
              // material: "Premium Cotton Blend",
                description:"Made from a soft fleece blend for all-day comfort. Clean streetwear design with minimal chest logo. Adjustable drawstrings with metal tips for style and fit. Relaxed drop-shoulder cut for laid-back comfort. Ribbed cuffs and hem keep the shape sharp. Perfect for everyday wear or layered street looks.",
    imgs: [
      "/Products/Hoodies/green/1.webp",
      "/Products/Hoodies/green/2.webp",
      "/Products/Hoodies/green/3.webp",
      "/Products/Hoodies/green/4.webp",
      "/Products/Hoodies/green/5.webp",
      "/Products/Hoodies/green/6.webp",
      // "/Products/Hoodies/Green/7.webp",
      // "/Products/Hoodies/Green/8.webp",
    ],
    },
  ];

const jackets= [
  {
    id: 4,
    name: "Novera Black Jacket",
    oldPrice: 5999,
    price: 4250,
    sizes: ["S", "M", "L", "XL"],
    color: "Black",
    // material: "Genuine Leather",
    description:
        "Modern utility design with contrasting nylon patch pockets. Full front zip closure for a sleek, urban look. Soft fleece base for warmth and comfort. Lightweight yet structured for everyday wear. Versatile — pairs effortlessly with joggers or cargos.",
    imgs: [
      "/Products/jackets/1.webp",
      "/Products/jackets/2.webp",
      "/Products/jackets/3.webp",
      "/Products/jackets/4.webp",
      "/Products/jackets/5.webp",

    ],
  },
  {
    id: 5,
    name: "Bandana Craft Jacket",
    oldPrice: 4999,
    price: 3999,
    sizes: ["M", "L", "XL"],
    color: "White",
    // material: "100% Denim",
    description:
        "Bold all-over bandana print for standout street style. Soft cotton-blend fabric for a smooth, comfy feel. Contrast black collar adds a sharp modern edge. Front flap pockets bring a functional street vibe. Lightweight design, ideal for layering. Perfect balance of trend and comfort.",
            imgs: [
      "/Products/jackets/allover/1.webp",
      "/Products/jackets/allover/2.webp",
      "/Products/jackets/allover/3.webp",
      "/Products/jackets/allover/4.webp",
      "/Products/jackets/allover/5.webp",
    
    ],
  },
];

 const  trackSuit= [
    {
      id: 6,
      name: "Nuvrik Black Set",
      oldPrice: 7999,
      price: 5550,
      sizes: ["S", "M", "L", "XL"],
      color: "Black",
      // material: "Cotton Jersey",
      description:
        " Premium  tracksuit with clean streetwear look. Soft fleece fabric for comfort and warmth. Button-up top with front pockets. Relaxed fit for easy movement.Elastic waist pants for a perfect fit. Ideal for casual wear or travel.",
              imgs: [
        "/Products/Tracksuit/1.webp",
        "/Products/Tracksuit/2.webp",
        "/Products/Tracksuit/3.webp",
        "/Products/Tracksuit/4.webp",
        "/Products/Tracksuit/5.webp",
      ],
    },
    {
      id: 7,
      name: "Mavrik Black Set",
      oldPrice: 6999,
      price: 4850,
      sizes: ["M", "L", "XL"],
      color: "Black",
      // material: "Cotton Jersey",
      description:
        " Ultra-Warm Fleece Keeps you cozy and comfortable in chilly weather. Perfectly fit for Athletic design that enhances your style and movement.  Soft fleece that blends with a smooth inner lining.  Ideal for workouts, travel, or casual wear.  Simple design with a luxury winter vibe.",
              imgs: [
        "/Products/Tracksuit/black/1.webp",
        "/Products/Tracksuit/black/2.webp",
        "/Products/Tracksuit/black/3.webp",
        "/Products/Tracksuit/black/4.webp",
        "/Products/Tracksuit/black/5.webp",
      ],
    },
    {
      id: 8,
      name: "Mavrik White Set",
      oldPrice: 6999,
      price: 4850,
      sizes: ["M", "L", "XL"],
      color: "White",
      // material: "Cotton Jersey",
      description:
        " Ultra-Warm Fleece Keeps you cozy and comfortable in chilly weather. Perfectly fit for Athletic design that enhances your style and movement.  Soft fleece that blends with a smooth inner lining.  Ideal for workouts, travel, or casual wear.  Simple design with a luxury winter vibe.",
              imgs: [
        "/Products/Tracksuit/white/1.webp",
        "/Products/Tracksuit/white/2.webp",
        "/Products/Tracksuit/white/3.webp",
        "/Products/Tracksuit/white/4.webp",
        "/Products/Tracksuit/white/5.webp",
    
      ],
    },
  ];
  const  polo= [
      {
        id: 9,
        name: "Mavrik White Polo",
        oldPrice: 3999,
        price: 2550,
        sizes: ["M", "L", "XL"],
        color: "White",
        // material: "Cotton Piqué",
        description:
        " Bold oversized white graphic print for a statement look. Contrasting white collar adds a sharp, modern edge. Soft cotton fleece fabric ensures all-day comfort. Perfect balance of streetwear and smart-casual style. Easy to pair with joggers, cargos, or denim.",
                imgs: [
          "/Products/Polo/1.webp",
          "/Products/Polo/2.webp",
          "/Products/Polo/3.webp",
          "/Products/Polo/4.webp",
          "/Products/Polo/5.webp",
        ],
      },
      {
        id: 10,
        name: "Mavrik Black Polo",
        oldPrice: 3999,
        price: 2550,
        sizes: ["M", "L", "XL"],
        color: "Black",
        // material: "Cotton Piqué",
        description:
        " Bold oversized blackgraphic print for a statement look. Contrasting black collar adds a sharp, modern edge. Soft cotton fleece fabric ensures all-day comfort. Perfect balance of streetwear and smart-casual style. Easy to pair with joggers, cargos, or denim.",
                imgs: [
          "/Products/Polo/Black/1.webp",
          "/Products/Polo/Black/2.webp",
          "/Products/Polo/Black/3.webp",
          "/Products/Polo/Black/4.webp",
          "/Products/Polo/Black/5.webp",
          // "/Products/Polo/Black/6.webp",
        ],
      },
    ];
       const trousers= [
        {
          id: 11,
          name: "Platted White Bottom",
          oldPrice: 3999,
          price: 2750,
          sizes: ["M", "L", "XL"],
          // sizes: ["S", "M", "L", "XL"],
          color: "White",
          // material: "Cotton Blend",
          description:
        " Premium heavy-weight fleece for comfort and structure. Relaxed wide-leg fit for a bold streetwear look. Elastic waistband with drawstring for a custom fit. Side pockets for everyday utility. Subtle panel detailing along the legs.",
                  imgs: [
            "/Products/Trouser/1.webp",
            "/Products/Trouser/2.webp",
            "/Products/Trouser/3.webp",
            "/Products/Trouser/4.webp",
            "/Products/Trouser/5.webp",
            // "/Products/Trouser/6.webp",
          ],
        },
        {
          id: 12,
          name: "Platted Black Bottom",
          oldPrice: 3999,
          price: 2750,
          sizes: ["M", "L", "XL"],
          color: "Black",
          // material: "Cotton Blend",
          description:
        "Premium heavy-weight fleece for comfort and structure. Relaxed wide-leg fit for a bold streetwear look. Elastic waistband with drawstring for a custom fit. Side pockets for everyday utility. Subtle panel detailing along the legs.",
                  imgs: [
            "/Products/Trouser/Black/1.webp",
            "/Products/Trouser/Black/2.webp",
            "/Products/Trouser/Black/3.webp",
            "/Products/Trouser/Black/4.webp",
            "/Products/Trouser/Black/5.webp",
          ],
        },
      ];
 const NewArrivals = [
  ...hoodies,
  ...jackets,
  ...trackSuit,
  // ...polo,
  // ...trousers
  // optionally slice few if you just want recent few
  // ...hoodies.slice(0, 1), ...jackets.slice(0, 1), etc.
];
       const stockData = {
 NewArrivals,
  hoodies,
  jackets,
  trackSuit,
  polo,
  trousers
};
export default stockData;
